(function () {
  'use strict';

  var SECTION_SELECTOR = '[data-mcpg-section]';

  function getRootUrl(section) {
    var root = section.dataset.rootUrl || (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return root.endsWith('/') ? root : root + '/';
  }

  function getCartUi() {
    return document.querySelector('cart-drawer') || document.querySelector('cart-notification');
  }

  function getCartSectionIds() {
    var cartUi = getCartUi();

    if (cartUi && typeof cartUi.getSectionsToRender === 'function') {
      try {
        var ids = cartUi.getSectionsToRender().map(function (section) {
          return section.id;
        }).filter(Boolean);

        if (ids.length) {
          return ids.slice(0, 5);
        }
      } catch (error) {
        // Use the safe fallback below.
      }
    }

    return ['cart-icon-bubble'];
  }

  function replaceSectionFromHtml(sectionId, html) {
    if (!html) {
      return false;
    }

    var documentHtml = new DOMParser().parseFromString(html, 'text/html');
    var selectors = [
      '#shopify-section-' + sectionId,
      '#' + sectionId,
      '#cart-icon-bubble'
    ];

    for (var index = 0; index < selectors.length; index += 1) {
      var selector = selectors[index];
      var current = document.querySelector(selector);
      var fresh = documentHtml.querySelector(selector);

      if (current && fresh) {
        current.replaceWith(fresh);
        return true;
      }
    }

    return false;
  }

  function renderReturnedCartSections(data) {
    if (!data || !data.sections) {
      return false;
    }

    var rendered = false;

    Object.keys(data.sections).forEach(function (sectionId) {
      rendered = replaceSectionFromHtml(sectionId, data.sections[sectionId]) || rendered;
    });

    return rendered;
  }

  function updateFallbackCartCount(cart) {
    if (!cart || typeof cart.item_count === 'undefined') {
      return;
    }

    var count = Number(cart.item_count || 0);
    var countText = String(count);

    document.querySelectorAll('[data-ph-cart-count], .cart-count-bubble span[aria-hidden="true"], .cart-count-bubble .cart-count').forEach(function (element) {
      element.textContent = countText;
    });

    document.querySelectorAll('[data-ph-cart-count-bubble], .cart-count-bubble').forEach(function (bubble) {
      bubble.classList.toggle('is-hidden', count === 0);
    });
  }

  function dispatchCartEvents(cart, addedData) {
    var detail = {
      cart: cart,
      data: addedData,
      source: 'manual-collection-product-grid'
    };

    ['cart:refresh', 'cart:updated', 'cart:change'].forEach(function (eventName) {
      document.dispatchEvent(new CustomEvent(eventName, { bubbles: true, detail: detail }));
      window.dispatchEvent(new CustomEvent(eventName, { detail: detail }));
    });
  }

  async function fetchCart(section) {
    var response = await fetch(getRootUrl(section) + 'cart.js', {
      method: 'GET',
      headers: {
        Accept: 'application/json'
      }
    });

    if (!response.ok) {
      throw new Error('Could not refresh cart.');
    }

    return response.json();
  }

  async function addVariant(section, variantId, quantity) {
    var sectionIds = getCartSectionIds();
    var payload = {
      id: Number(variantId),
      quantity: Math.max(1, Number(quantity || 1)),
      sections: sectionIds.join(','),
      sections_url: window.location.pathname + window.location.search
    };

    var response = await fetch(getRootUrl(section) + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify(payload)
    });

    var data = await response.json().catch(function () {
      return {};
    });

    if (!response.ok) {
      throw new Error(data.description || data.message || 'Unable to add this product.');
    }

    return data;
  }

  function renderCart(section, data, cart) {
    var cartUi = getCartUi();
    var renderedByTheme = false;

    if (cartUi && typeof cartUi.renderContents === 'function') {
      try {
        if (cartUi.classList) {
          cartUi.classList.remove('is-empty');
        }
        cartUi.renderContents(data);
        renderedByTheme = true;
      } catch (error) {
        renderedByTheme = false;
      }
    }

    if (!renderedByTheme) {
      renderReturnedCartSections(data);
    }

    updateFallbackCartCount(cart);
    dispatchCartEvents(cart, data);

    if (section.dataset.openCartAfterAdd === 'true') {
      window.setTimeout(function () {
        var currentCartUi = getCartUi();
        var customCartButton = document.querySelector('[data-ph-cart-open]');

        if (currentCartUi && typeof currentCartUi.open === 'function') {
          currentCartUi.open();
        } else if (customCartButton) {
          customCartButton.click();
        }
      }, 80);
    }
  }

  function getElements(card) {
    return {
      form: card.querySelector('[data-mcpg-form]'),
      select: card.querySelector('[data-mcpg-variant-select]'),
      input: card.querySelector('[data-mcpg-variant-input]'),
      button: card.querySelector('[data-mcpg-add-button]'),
      buttonText: card.querySelector('[data-mcpg-button-text]'),
      price: card.querySelector('[data-mcpg-price]'),
      comparePrice: card.querySelector('[data-mcpg-compare-price]'),
      saleBadge: card.querySelector('[data-mcpg-sale-badge]'),
      image: card.querySelector('.manual-collection-grid__image'),
      message: card.querySelector('[data-mcpg-message]')
    };
  }

  function getSelectedOption(elements) {
    if (!elements.select) {
      return null;
    }

    return elements.select.options[elements.select.selectedIndex] || null;
  }

  function getVariantId(elements) {
    if (elements.select) {
      return elements.select.value;
    }

    return elements.input ? elements.input.value : '';
  }

  function setMessage(elements, text, isError) {
    if (!elements.message) {
      return;
    }

    elements.message.textContent = text || '';
    elements.message.classList.toggle('is-error', Boolean(isError));
  }

  function setButtonState(elements, available) {
    if (!elements.button) {
      return;
    }

    elements.button.disabled = !available;

    if (elements.buttonText) {
      elements.buttonText.textContent = available
        ? (elements.button.dataset.defaultText || 'Add to Cart')
        : (elements.button.dataset.soldOutText || 'Sold Out');
    }
  }

  function updateCardFromVariant(card) {
    var elements = getElements(card);
    var option = getSelectedOption(elements);

    if (!option) {
      return;
    }

    var available = option.dataset.available !== 'false';
    var onSale = option.dataset.onSale === 'true';

    if (elements.price && option.dataset.price) {
      elements.price.textContent = option.dataset.price;
    }

    if (elements.comparePrice) {
      elements.comparePrice.textContent = onSale ? (option.dataset.comparePrice || '') : '';
      elements.comparePrice.classList.toggle('is-hidden', !onSale);
    }

    if (elements.saleBadge) {
      elements.saleBadge.classList.toggle('is-hidden', !onSale);
    }

    if (elements.image && option.dataset.image) {
      elements.image.src = option.dataset.image;
      elements.image.removeAttribute('srcset');
      elements.image.removeAttribute('sizes');
      elements.image.alt = option.dataset.imageAlt || elements.image.alt || '';
    }

    setButtonState(elements, available);
    setMessage(elements, '', false);
  }

  function initCard(section, card) {
    if (!card || card.dataset.mcpgReady === 'true') {
      return;
    }

    card.dataset.mcpgReady = 'true';

    var elements = getElements(card);

    if (!elements.form || !elements.button) {
      return;
    }

    if (elements.select) {
      elements.select.addEventListener('change', function () {
        updateCardFromVariant(card);
      });
    }

    elements.form.addEventListener('submit', async function (event) {
      event.preventDefault();
      event.stopPropagation();

      var variantId = getVariantId(elements);

      if (!variantId || elements.button.disabled || elements.button.dataset.busy === 'true') {
        return;
      }

      elements.button.dataset.busy = 'true';
      elements.button.disabled = true;
      elements.button.classList.remove('is-added', 'is-error');
      elements.button.classList.add('is-loading');
      setMessage(elements, '', false);

      if (elements.buttonText) {
        elements.buttonText.textContent = elements.button.dataset.loadingText || 'Adding...';
      }

      try {
        var data = await addVariant(section, variantId, 1);
        var cart = await fetchCart(section);

        renderCart(section, data, cart);

        elements.button.classList.remove('is-loading');
        elements.button.classList.add('is-added');

        if (elements.buttonText) {
          elements.buttonText.textContent = elements.button.dataset.addedText || 'Added';
        }

        window.setTimeout(function () {
          elements.button.classList.remove('is-added');
          elements.button.dataset.busy = 'false';
          updateCardFromVariant(card);

          if (!elements.select) {
            setButtonState(elements, true);
          }
        }, 1500);
      } catch (error) {
        elements.button.classList.remove('is-loading');
        elements.button.classList.add('is-error');
        elements.button.dataset.busy = 'false';
        elements.button.disabled = false;

        if (elements.buttonText) {
          elements.buttonText.textContent = elements.button.dataset.errorText || 'Unable to add';
        }

        setMessage(elements, error && error.message ? error.message : 'Unable to add this product.', true);

        window.setTimeout(function () {
          elements.button.classList.remove('is-error');
          updateCardFromVariant(card);

          if (!elements.select) {
            setButtonState(elements, true);
          }
        }, 2200);
      }
    });

    updateCardFromVariant(card);
  }

  function initSection(section) {
    if (!section || section.dataset.mcpgReady === 'true') {
      return;
    }

    section.dataset.mcpgReady = 'true';

    section.querySelectorAll('[data-mcpg-card]').forEach(function (card) {
      initCard(section, card);
    });
  }

  function initAllSections() {
    document.querySelectorAll(SECTION_SELECTOR).forEach(function (section) {
      initSection(section);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllSections);
  } else {
    initAllSections();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target.matches && event.target.matches(SECTION_SELECTOR)
      ? event.target
      : event.target.querySelector(SECTION_SELECTOR);

    if (section) {
      initSection(section);
    }
  });
})();